import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgExportToExcel = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 26 26",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M24.9999 1L15.1602 10.84",
			stroke: "currentColor",
			strokeWidth: 1.3,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.1992 6.00391V11.7999H19.9951",
			stroke: "currentColor",
			strokeWidth: 1.3,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.7998 1H9.39982C3.39995 1 1 3.4 1 9.4V16.6C1 22.6 3.39995 25 9.39982 25H16.5997C22.5995 25 24.9995 22.6 24.9995 16.6V14.2",
			stroke: "currentColor",
			strokeWidth: 1.3,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgExportToExcel;
